export default __webpack_public_path__ + "static/media/brand_passcard.80f4203e.svg";